import { Drawer } from 'antd';
import { useDispatch } from 'react-redux';
import type { RootDispatch } from '@/state/store';
import {
    FormCompartilhar,
    type FormCompartilharValues,
    type ICompartilhar,
} from '@/components/revisar/FormCompartilhar';
import { enviarNotaFiscalPorWhatsapp } from '@/features/notificacao/util/nota-fiscal';
import { createDialogStore } from '@/std/dialog/createDialogStore';

export const useNotaFiscalDrawerCompartilhar = createDialogStore<ICompartilhar>();

export function DrawerCompartilhar() {
    const dispatch = useDispatch<RootDispatch>();

    const state = useNotaFiscalDrawerCompartilhar((s) => s.state);
    const actions = useNotaFiscalDrawerCompartilhar((s) => s.actions);

    const enviarEmail = async (values: FormCompartilharValues): Promise<void> => {
        if (!state.data) {
            return;
        }

        const url = new URL(state.data.link);
        url.searchParams.set('registrarVisualizacao', 'true');

        const body = {
            fin_email: values.email,
            fin_email_cc: values.com_copia,
            tags: [
                {
                    nome: 'email_assunto',
                    valor: values.assunto || state.data.assunto,
                },
                {
                    nome: 'mensagem',
                    valor: values.mensagem,
                },
                {
                    nome: 'url',
                    valor: url.toString(),
                },
            ],
        };

        const params = {
            fin_email: body.fin_email,
            fin_email_cc: body.fin_email_cc,
            idpk: state.data.idpk || 0,
            tags: body.tags,
            template_id: 'EMPRESA_PADRAO',
            tipo: 'E',
        };

        await dispatch.notaFiscal.compartilharSend(params);
    };

    const enviarWhatsapp = async (values: FormCompartilharValues): Promise<void> => {
        if (!state.data) {
            return;
        }

        await enviarNotaFiscalPorWhatsapp(values, state.data, () => actions.close());
    };

    return (
        <Drawer
            onClose={() => actions.close()}
            open={state.open}
            styles={{
                body: {
                    overflow: 'auto',
                    padding: '5px',
                },
            }}
            title='Compartilhar Nota Fiscal'
        >
            {state.data ? (
                <FormCompartilhar
                    assunto={state.data.assunto}
                    email={state.data.email}
                    enviarEmail={enviarEmail}
                    enviarWhatsapp={enviarWhatsapp}
                    link={state.data.link}
                    mensagem={state.data.mensagem}
                    onClose={() => actions.close()}
                    telefone={state.data.telefone}
                />
            ) : null}
        </Drawer>
    );
}
